import { combineEpics } from "redux-observable";
import { epicBalloonOfferBuyWithGold } from "./epics/epicBalloonOfferBuyWithGold";
import { epicBalloonOfferClose } from "./epics/epicBalloonOfferClose";
import { epicBalloonOfferConsume } from "./epics/epicBalloonOfferConsume";
export var epicBalloonInfo = combineEpics(epicBalloonOfferConsume, epicBalloonOfferClose, epicBalloonOfferBuyWithGold);



//////////////////
// WEBPACK FOOTER
// ./src/features/info/balloon/epicBalloonInfo.ts
// module id = 1897
// module chunks = 3